import ExternalLink from '../lib/ExternalLink';

export default function v1JsExternalLink() {
  window.addEventListener('load', () => {
    const externalLink = new ExternalLink();
    externalLink.init();
  });
}
